import type { Mapper } from '@empathyco/x-adapter'
import type { Result } from '@empathyco/x-types'
import type { SearchResponse } from '../types'
import { schemaMapperFactory } from '@empathyco/x-adapter'
import { searchResponseSchema } from '../schemas/search-response.schema'

const RAW_RESULT_EXCLUDED_KEYS = new Set(['debugProperties', 'product', 'modelName'])

/**
 * Keeps catalog fields from the Play response so consumers can resolve
 * `resultMappings.id` (e.g. `upc`, `sku`) from the mapped result.
 */
export function getCatalogFieldsFromRawResult(
  raw: Record<string, unknown> | undefined,
): Record<string, unknown> {
  if (!raw) {
    return {}
  }

  return Object.fromEntries(
    Object.entries(raw).filter(
      ([key]) => !key.startsWith('__') && !RAW_RESULT_EXCLUDED_KEYS.has(key),
    ),
  )
}

export function addPositionsAndRemoveScoreOnPinnedProducts(
  results: Array<Result>,
  start: number,
): Array<Result> {
  return results.map((result, index) => {
    if (result.debug) {
      const debug = {
        ...result.debug,
        position: start + index + 1,
      }

      if (result.debug.pin?.position) {
        debug.sort = []
      }

      return {
        ...result,
        debug,
      }
    }

    return result
  })
}

export const searchResponseMapper: Mapper<any, SearchResponse> = (from, context) => {
  const to = schemaMapperFactory(searchResponseSchema)(from, context)
  const start = Number(context.requestParameters?.start ?? 0)
  const rawContent: Array<Record<string, unknown>> = from?.catalog?.content ?? []

  const results = addPositionsAndRemoveScoreOnPinnedProducts(to.results, start).map(
    (result, index) => ({
      ...getCatalogFieldsFromRawResult(rawContent[index]),
      ...result,
    }),
  )

  return {
    ...to,
    results,
  }
}
